import { Alert, Card, Divider, Typography } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';

import WizardContentBox from '../components/WizardContentBox';
import { WizardDescription } from '../components/WizardDescription';
import ReasoningModal from '../components/ReasoningModal';
import TemplateSubmissionSteps from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/TemplateSubmissionSteps';

/**
 * Recommendation step for users submitting fewer than 15 products.
 * Recommends using the Product Submission Grid.
 */
export const RecommendationGridStep = ({ step }) => {
  const { content } = step;

  return (
    <WizardContentBox className='recommendation-grid'>
      <WizardDescription>{content.description}</WizardDescription>
      {content.warning && (
        <Alert
          message={content.warning}
          type='warning'
          showIcon
          style={{ marginTop: 16 }}
        />
      )}
      <ReasoningModal />
    </WizardContentBox>
  );
};

/**
 * Recommendation step for users submitting more than 15 products.
 * Recommends using the product template for bulk upload.
 */
export const RecommendationTemplateStep = ({ step }) => {
  const { content } = step;

  return (
    <WizardContentBox className='recommendation-template'>
      <WizardDescription>{content.description}</WizardDescription>
      <ReasoningModal />

      <Card className='wizard-submission-method__card recommendation-template__card'>
        <div className='wizard-submission-method__heading'>
          <span className='wizard-submission-method__icon'>
            <FileTextOutlined />
          </span>
          <Typography.Title level={5}>Template</Typography.Title>
        </div>
        <WizardDescription>
          To use a template to build your item(s) in the Product Submission Grid:
        </WizardDescription>
        <TemplateSubmissionSteps />

        <Divider />

        <div className='recommendation-template__instructions'>
          <WizardDescription>
            <Typography.Text strong>INSTRUCTIONS: </Typography.Text>
            Please fill out all columns in the product template that are relevant
            to your products, leaving any non-pertinent columns BLANK. It is
            imperative that proper codes for all product levels be filled out
            accurately on the submitted template to prevent delays in processing.
          </WizardDescription>
          <WizardDescription>
            <Typography.Text strong>NEXT: </Typography.Text>
            If your template is complete, click{' '}
            <Typography.Text strong>[Upload Template]</Typography.Text> above.
            Otherwise, when ready restart this wizard, select{' '}
            <Typography.Text strong>[Grid / Template]</Typography.Text>, and
            choose <Typography.Text strong>[Upload Template].</Typography.Text>
          </WizardDescription>
          <WizardDescription>
            Once the template is loaded into our system, you will be able to
            validate the data onscreen prior to submission. Upon submission,
            shipping authorization instructions to ship live retail ready master
            case(s) will be sent via email.
          </WizardDescription>
          <Alert
            message='Please wait on this authorization before shipping to avoid delays or loss of product.'
            type='warning'
            showIcon
          />
        </div>
      </Card>
    </WizardContentBox>
  );
};
